import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

/**
 * BreadcrumbContext
 * -----------------
 * Cho phép từng page đẩy dữ liệu breadcrumb (và bật/tắt thanh search) lên
 * header chung (NavbarTop) — vì breadcrumb sống trong NavbarTop, là sibling
 * của <Outlet/>, nên không thể truyền prop trực tiếp từ page.
 *
 * - items: mảng breadcrumb do page set. `null` => component tự suy ra từ URL.
 * - searchVisible: hiện/ẩn thanh search ở header (mặc định hiện ở mọi page).
 *
 * Page dùng hook `useBreadcrumb` (src/hooks/useBreadcrumb.js), không dùng
 * context này trực tiếp. NavbarTop/PebBreadcrumb dùng `useBreadcrumbState`.
 */
const BreadcrumbContext = createContext({
  items: null,
  setItems: () => {},
  searchVisible: true,
  setSearchVisible: () => {}
});

export const BreadcrumbProvider = ({ children }) => {
  const [items, setItems] = useState(null);
  const [searchVisible, setSearchVisible] = useState(true);

  const value = useMemo(
    () => ({ items, setItems, searchVisible, setSearchVisible }),
    [items, searchVisible]
  );

  return (
    <BreadcrumbContext.Provider value={value}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

BreadcrumbProvider.propTypes = {
  children: PropTypes.node
};

// Hook nội bộ cho NavbarTop / PebBreadcrumb đọc state.
export const useBreadcrumbState = () => useContext(BreadcrumbContext);

export default BreadcrumbContext;
